import React, {
  useState,
  useEffect,
  useCallback,
  useMemo,
  useRef,
} from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import {
  getstaffDesignation,
  addEditStaff,
  addEditStaffInvite,
  editStaff,
  getOfficesDetail,
} from "actions/index";
import Input from "components/Input";
import _isLoading from "hoc/isLoading";
import Toast from "components/Toast";
import { withTranslation } from "react-i18next";
import SubstituteSelectorFactory from "./../../../components/SubstituteSelector";
import constants from "./../../../constants";
import { getLeaveDetail } from "repositories/leave-repository";
import { getPerformanceReviews } from "repositories/performance-repository";
import TitleInput from "components/TitleInput";
import * as moment from "moment";
import { decodeId } from "utils";
import Text from "components/Text";
import "../HourlyRateHistory/HourlyRate.scss";
import ReactDatePickerCommon from "components/ReactDatePickerCommon";
import OtherCompensationInputs from "./OtherCompensationInputs";
import AccordionWrapper from "./AccordionWrapper";
import SelectionAndModal, {
  OfficeSelectionAndModal,
} from "./SelectionAndModal";
import {
  acceptRequestEventToJoin,
  useOwnerSpecificStaffDesignation,
} from "repositories/scheduler-repository";

// Import new components
import EmailInput from "./components/EmailInput";
import RoleCheckbox from "./components/RoleCheckbox";
import ScheduleSelection from "./components/ScheduleSelection";
import ProfileColorPicker from "./components/ProfileColorPicker";
import StaffTypeRadio from "./components/StaffTypeRadio";
import FormButtons from "./components/FormButtons";
import BackButton from "./components/BackButton";
import PrivacyNotice from "./components/PrivacyNotice";
import { Tooltip } from "reactstrap";
import { useAccountOwnerCommon } from "lib/Context/AccountOwner";
import { v4 as uuidv4 } from "uuid"; // Import UUID library
import styles from "../staff.module.scss";
import addStaffStyles from "./AddStaff.module.scss";
import {
  editPreSetterValues,
  fieldDefaultEmptyState,
  fieldDefaultState,
  generatePayloadForBulk,
  isValidFields,
  payloadGenerate,
} from "./addstaff.functions";
import { useGetAdminStaffOfficeList } from "repositories/office-repository";
import {
  addGlobalStaff,
  getGlobalStaffDetail,
  updateBulkStaff,
} from "repositories/staff-repository";
import toast from "react-hot-toast";
import Loader from "components/Loader";
import { cloneDeep } from "lodash";
import DeleteOfficeAssignmentModal from "./DeleteOfficeAssignmentModal";
import { convertStaffData } from "../StaffDetail/staffdetail.functions";
import tooltipImg from "assets/images/info_black-tooltip.svg";
import AddStaffHelpGuideModal from "./AddStaffHelpGuideModal";
import QuestionIcon from "assets/images/question_mark.svg";
import defautUserImage from "assets/images/staff-default.svg";
import CloseIcon from "assets/images/cross.svg";

export const RedDot = () => {
  return <span style={{ color: "#EE4F4F" }}>*</span>;
};

const AddStaff = ({
  profile,
  // staffDesignation,
  statusMessage,
  isAddedError,
  isStaffAdd,
  officeDetail,
  // getstaffDesignation,
  addEditStaff,
  addEditStaffInvite,
  editStaff,
  getOfficesDetail,
  t,
}) => {
  const history = useHistory();
  const location = useLocation();
  const locationState = location.state;
  const params = useParams();
  const timeoutRef = useRef(null);
  const dispatch = useDispatch();
  const officeId = parseInt(decodeId(params.id));
  const [globalLoading, setGlobalLoading] = useState(false);
  const [isInfoModalOpen, setIsInfoModalOpen] = useState(false);
  const [globalStaffDetail, setGlobalStaffDetail] = useState(null);
  const { isOwner: isAccountOwner } = useAccountOwnerCommon();
  const containerRef = useRef(null);
  const popupRef = useRef(null);
  const [showPopup, setShowPopup] = useState(false);
  const [position, setPosition] = useState({ left: 0, top: 0 });
const {getIdToCheckOwnerChange,selectedId}=useAccountOwnerCommon();
const globalStaffPage = useMemo(
  () => location.pathname.includes(constants.routes.globalStaffAdd),
  [],
);
useEffect(()=>{
  if(getIdToCheckOwnerChange()){
    history.push(constants.routes.globalStaffList);
  }
},[selectedId]);
  const {
    isUpdateMultipleStaffForMultipleOffices,
    isUpdateMultipleStaffForSingleOffice,
    isUpdateStaffForMultipleOffices,
  } = useMemo(
    () => ({
      isUpdateStaffForMultipleOffices: location.pathname.includes(
        constants.routes.accountOwner.updateStaffForMultipleOffices,
      ),
      isUpdateMultipleStaffForSingleOffice: location.pathname.includes(
        constants.routes.accountOwner.updateMultipleStaffForSingleOffice,
      ),
      isUpdateMultipleStaffForMultipleOffices: location.pathname.includes(
        constants.routes.accountOwner.updateMultipleStaffForMultipleOffices,
      ),
    }),
    [],
  );
  const ownerId = locationState?.ownerId || officeDetail?.ownerId;
  const globalOwnerId = location.state?.ownerId;
  const { data: staff_designation } = useOwnerSpecificStaffDesignation(
    { selectedId: ownerId },
    { enabled: !!ownerId },
  );
  const { data: office_list, isLoading: isOfficeLoading } =
    useGetAdminStaffOfficeList(globalOwnerId, {
      enabled: globalStaffPage && !!globalOwnerId,
    });

  const submittedRef = useRef(false);
  // State initialization
  const [state, setState] = useState({
    staffId: 0,
    inviteId: 0,
    userId: 0,
    officeId,
    title: 6,
    firstName: "",
    lastName: "",
    emailId: "",
    contactNumber: "",
    profileColor: "",
    isToastView: false,
    address: "",
    socialSecurityNumber: "",
    sikkaProviderId: null,
    isProps: true,
    substituteSelectorEvent: null,
    isLoggedInUserSeeHourlyRate: false,
    errors: {},
    reviewFormList: [{ id: "0", name: "Select Performance Review" }],
    loadingLeaveDetail: false,
    loadingReviewList: false,
    fields: [
      {
        key: uuidv4(),
        ...cloneDeep(fieldDefaultState),
      },
    ],
    IsAutoAcceptStaff: location?.state && "otherOfficeDetail" in location.state,
    reOpen: false,
  });
  const defaultDesignationId = useMemo(() => {
    if (staff_designation?.designations_list?.length) {
      return staff_designation?.designations_list.find(
        (item) => item.isDefaultRole,
      );
    }
    return null;
  }, [staff_designation, globalStaffDetail?.id]);
  useEffect(() => {
    const fieldData = state.fields[0];
    if (
      defaultDesignationId &&
      ((globalStaffDetail?.id && location.pathname.includes("/editStaff")) ||
        location.pathname.includes("AddStaff")) &&
      !fieldData.designationId
    ) {
      if (defaultDesignationId?.id) {
        updateFieldState(
          { ...fieldData, designationId: defaultDesignationId?.id },
          0,
        );
      }
    }
  }, [globalStaffDetail?.id, defaultDesignationId]);
  const debounceRef = useRef();

  const validate = (data) => {
    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
    }
    debounceRef.current = setTimeout(() => {
      if (submittedRef.current) {
        isValidFields({
          t,
          state: data || state,
          InputChange,
          setState,
          location,
          globalStaffPage,
        });
      }
    }, 1000);
  };

  // Update state helper
  const updateState = useCallback((updates) => {
    setState((prev) => {
      const values = { ...prev, isProps: false, ...updates };
      validate(values);
      return values;
    });
  }, []);
  const updateFieldState = useCallback((updates, index) => {
    setState((prev) => {
      const prevField = prev.fields;
      prevField[index] = updates;
      const values = { ...prev, isProps: false, fields: [...prevField] };
      validate(values);
      return values;
    });
  }, []);
  useEffect(() => {
    if (
      isUpdateStaffForMultipleOffices ||
      isUpdateMultipleStaffForSingleOffice ||
      isUpdateMultipleStaffForMultipleOffices
    ) {
      updateFieldState(
        { key: uuidv4(), ...cloneDeep(fieldDefaultEmptyState) },
        0,
      );
    }
  }, [
    isUpdateStaffForMultipleOffices,
    isUpdateMultipleStaffForSingleOffice,
    isUpdateMultipleStaffForMultipleOffices,
    updateFieldState,
  ]);
  const fetchPerformanceReviews = useCallback(async (officeId, userId) => {
    getPerformanceReviewsApi(officeId, userId);
  }, []);

  const fetchLeaveDetail = useCallback(async (staffId, invitationId) => {
    const apiRes = staffId
      ? await getLeaveDetail(staffId)
      : await getLeaveDetail(null, invitationId);

    if (apiRes?.statusCode === 200) {
      handleLeaveDetailResponse(apiRes);
    }
  }, []);

  useEffect(() => {
    if (!locationState) return;

    const initializeData = async () => {
      const staffDetail = locationState.staffDetail;
      if (
        isUpdateStaffForMultipleOffices ||
        (!globalStaffPage &&
          officeDetail?.id === officeId &&
          ownerId &&
          (locationState?.detail?.userId || staffDetail?.staffMemberId))
      ) {
        try {
          setGlobalLoading(true);
          const res = await getGlobalStaffDetail({
            ownerId: ownerId,
            userId: locationState?.detail?.userId || staffDetail.staffMemberId,
            isGlobal: isUpdateStaffForMultipleOffices || globalStaffPage,
            ...(globalStaffPage || isUpdateStaffForMultipleOffices
              ? {}
              : { officeId: +decodeId(params.id) }),
          });
          const data = res.data;
          if (data) {
            const allOffices = [];
            data.invitationInvitee.forEach((res) => {
              allOffices.push({
                id: res.officeId,
                name: res.office.name,
                inviteId: res.id,
                otherDetails: res,
              });
            });
            data.userOffice.forEach((res) => {
              allOffices.push({
                id: res.officeId,
                name: res.office.name,
                staffId: res.id,
                otherDetails: res,
              });
            });
            if (!isUpdateStaffForMultipleOffices) {
              const allValues = convertStaffData({
                fetchLeaveDetail,
                fetchPerformanceReviews,
                allOffices,
                officeIdSelectedView: +decodeId(params.id),
                staffMemberId:
                  locationState?.detail?.userId || staffDetail.staffMemberId,
                allData: data,
              });

              const {
                profilePic,
                firstName,
                lastName,
                emailId,
                contactNumber,
                address,
                socialSecurityNumber,
                streetAddress,
                city,
                country,
                state: provinceState,
                postalCode,
                honorific,
                colourCode,
              } = data;

              const addressView = [
                address || streetAddress,
                city?.name || "",
                provinceState?.name || "",
                country?.name || "",
                postalCode ? `(${postalCode})` : "",
              ]
                .filter((res) => !!res)
                .toString();
              editPreSetterValues({
                updateState,
                locationState: {
                  staffDetail: {
                    ...allValues,
                    profilePic,
                    firstName,
                    lastName,
                    emailId,
                    contactNumber,
                    address: addressView,
                    socialSecurityNumber,
                    honorific,
                    colourCode,
                  },
                },
                pathname: location.pathname,
              });
            }
            data.allOffices = allOffices;
            setGlobalStaffDetail(data);
          }
        } catch (error) {
        } finally {
          setGlobalLoading(false);
        }
        return;
      }
    };

    initializeData();
  }, [globalStaffPage, ownerId, isUpdateStaffForMultipleOffices]);

  // Initialize data
  useEffect(() => {
    if (isAccountOwner) {
      setState((prev) => ({ ...prev, isAccountOwner: true }));
    }
    if (globalStaffPage)
      return () => {
        dispatch({ type: "ResetStaffReducer" });
      };
    const officeIdForFetching = isUpdateMultipleStaffForSingleOffice
      ? locationState?.officeId
      : officeId;
    if (officeIdForFetching) {
      // getstaffDesignation(officeId);
      getOfficesDetail({ Id: officeIdForFetching });
    }

    if (
      isAccountOwner &&
      ((profile && profile.profileSetupStep === "packageExpired") ||
        profile.profileSetupStep === "subscriptionTerminated")
    ) {
      // history.push({
      //   pathname: constants.routes.accountOwner.staffGrid.replace(
      //     ":officeId",
      //     officeId
      //   ),
      //   state: { officeName: location?.state?.officeName },
      // });
      history.goBack();
    }
    if (location?.state?.otherOfficeDetail) {
      const values = location.state.otherOfficeDetail;
      updateState({
        emailId: values.emailId,
        firstName: values.firstName,
        lastName: values.lastName,
        designationId: values.designationId,
        roleId: values.roleId,
      });
    }
    return () => {
      dispatch({ type: "ResetStaffReducer" });
    };
  }, []);

  // Handle office detail changes
  useEffect(() => {
    if (
      !globalStaffPage &&
      officeDetail &&
      officeDetail?.id === officeId &&
      !officeDetail?.isActive
    ) {
      toast.error(`"${officeDetail?.name || "This"}" office is inactive.`);
      history.goBack();
    }
  }, [officeDetail]);

  // Handle staff add/update response
  useEffect(() => {
    if (isStaffAdd || isAddedError) {
      window.scrollTo(0, 0);
      setState((prev) => ({ ...prev, isToastView: true }));

      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }

      timeoutRef.current = setTimeout(() => {
        setState((prev) => ({ ...prev, isToastView: false }));
        if (!isStaffAdd) return;

        if (state.IsAutoAcceptStaff) {
          if (location?.state?.otherOfficeDetail?.eventId) {
            acceptRequestEventToJoin(
              location.state.otherOfficeDetail.eventId,
            ).then(() => {
              dispatch({ type: "ResetStaffReducer" });
              history.goBack();
            });
          } else {
            dispatch({ type: "ResetStaffReducer" });
            history.goBack();
          }
        } else {
          dispatch({ type: "ResetStaffReducer" });
          history.goBack();
        }
      }, 2500);
    }

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [isStaffAdd, isAddedError]);

  // Helper functions
  const handleLeaveDetailResponse = (apiRes) => {
    if (apiRes?.statusCode !== 200) return;

    const leaves = apiRes.data.map((it) => ({
      typeId: it.typeId,
      value: it.leaves.toString(),
      error: "",
    }));

    setState((prev) => ({
      ...prev,
      loadingLeaveDetail: false,
      fields: [{ ...prev.fields[0], leaves }],
    }));
  };

  const getPerformanceReviewsApi = async (officeId, userId) => {
    setState((prev) => ({ ...prev, loadingReviewList: true }));
    const apiRes = await getPerformanceReviews(officeId, userId);
    if (apiRes.statusCode !== 200) return;

    const reviewType = [
      "General",
      "ProbationPeriod",
      "MonthlyReview",
      "QuarterlyReview",
      "YearlyReview",
      "Others",
    ];
    const reviewFormList = [...state.reviewFormList];
    apiRes.data.map((it) =>
      reviewFormList.push({
        id: it.id,
        name:
          moment(it.createdAt).format("MMMM DD, YYYY") +
          " - " +
          reviewType[it.type],
      }),
    );
    setState((prev) => ({ ...prev, loadingReviewList: false, reviewFormList }));
  };

  const InputChange = (event) => {
    const { name, value } = event.target;
    updateState({ [name]: value });
  };

  const handleWeekDays = (event, fieldObject, fieldIndex) => {
    let weekArray = [...fieldObject.schedule];
    if (event.target.checked) {
      weekArray.push(event.target.value);
    } else {
      const index = weekArray.indexOf(event.target.value);
      weekArray.splice(index, 1);
    }
    updateFieldState({ ...fieldObject, schedule: [...weekArray] }, fieldIndex);
  };

  const handleWeekDaysEdit = (event, index, fieldObject, fieldIndex) => {
    const dataValue = [...fieldObject.scheduleWeek];
    dataValue[index].active = event.target.checked;
    updateFieldState({ ...fieldObject, scheduleWeek: dataValue }, fieldIndex);
    let weekArray = [...fieldObject.schedule];
    if (event.target.checked) {
      weekArray.push(event.target.value);
    } else {
      const _index = weekArray.indexOf(event.target.value);
      weekArray.splice(_index, 1);
    }
    updateFieldState({ ...fieldObject, schedule: [...weekArray] }, fieldIndex);
  };

  const scrollToError = () => {
    setTimeout(() => {
      const error = document.getElementsByClassName("error-msg");
      if (error?.length) {
        error[0].scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "start",
        });
      }
    }, 1000);
  };

  const handleAddstaff = () => {
    if (
      isUpdateStaffForMultipleOffices ||
      isUpdateMultipleStaffForSingleOffice ||
      isUpdateMultipleStaffForMultipleOffices
    ) {
      updateBulkAction();
      return;
    }
    submittedRef.current = true;
    const valid = isValidFields({
      t,
      state,
      InputChange,
      setState,
      location,
      globalStaffPage,
    });
    if (valid) {
      if (
        location.pathname.includes("/editStaff") &&
        !state?.sikkaProviderId &&
        globalStaffDetail.userOffice.find((res) => res.officeId === officeId)
          ?.isAdmin &&
        !state?.fields[0].isAdmin &&
        state?.staffId
      ) {
        startSubstituteSelectionJourney();
      } else {
        performAction();
      }
    } else {
      setState((prev) => ({ ...prev, reOpen: true }));
      scrollToError();
    }
  };
  const selectedFilteredOffices = useMemo(() => {
    if (isUpdateStaffForMultipleOffices) {
      const typeCheck = [
        constants.staffType.activated,
        constants.staffType.invitationPending,
      ];
      const allOffices = globalStaffDetail?.allOffices.filter((res) =>
        typeCheck.includes(res.otherDetails.type),
      );
      if (allOffices?.length) {
        const selectedoffices = locationState?.staffDetail?.selectedOfficeList;
        const allSelectedAndFiltered = allOffices.filter((res) =>
          selectedoffices.includes(res.id),
        );

        if (allOffices.length === selectedoffices.length) {
          return "Across All Offices";
        }
        return allSelectedAndFiltered;
      }
      return null;
    }
  }, [
    globalStaffDetail?.allOffices,
    isUpdateStaffForMultipleOffices,
    locationState?.staffDetail,
  ]);
  const officeNameForView = useMemo(() => {
    if (isUpdateMultipleStaffForMultipleOffices) {
      updateState({ title: 0 });
      return null;
    }
    if (isUpdateStaffForMultipleOffices) {
      updateState({ title: 0 });
      if (selectedFilteredOffices?.length) {
        if (typeof selectedFilteredOffices === "string") {
          return selectedFilteredOffices;
        }
        return selectedFilteredOffices.reduce((prev, curr, i) => {
          prev +=
            curr.name + (selectedFilteredOffices?.length - 1 === i ? "" : ", ");
          return prev;
        }, "");
      }
      return null;
    }
    if (isUpdateMultipleStaffForSingleOffice) {
      updateState({ title: 0 });
    }
    return officeDetail?.name || null;
  }, [
    selectedFilteredOffices,
    officeDetail?.name,
    isUpdateStaffForMultipleOffices,
  ]);
  const allUserList = useMemo(() => {
    if (isUpdateMultipleStaffForMultipleOffices) {
      return locationState?.userList.reduce(
        (prev, curr) => {
          if (!prev.existed.has(curr.staffMemberId)) {
            prev.data.push(curr);
            prev.existed.set(curr.staffMemberId, curr.staffMemberId);
          }
          return prev;
        },
        {
          existed: new Map(),
          data: [],
        },
      ).data;
    }
    if (isUpdateMultipleStaffForSingleOffice) {
      return locationState?.userList;
    }
    if (globalStaffDetail?.id) {
      return [
        {
          id: globalStaffDetail?.id,
          firstName: globalStaffDetail?.firstName,
          lastName: globalStaffDetail?.lastName,
          profilePic: globalStaffDetail?.profilePic,
        },
      ];
    }
    return [];
  }, [globalStaffDetail?.id]);

  const updateBulkAction = async () => {
    const { submit, payload } = generatePayloadForBulk({ state });

    if (!submit) {
      return toast.error("At least update one field");
    }
    try {
      payload.IsAllOffice =
        isUpdateStaffForMultipleOffices &&
        typeof selectedFilteredOffices === "string";
      payload.officeIds = payload.IsAllOffice
        ? []
        : isUpdateMultipleStaffForMultipleOffices ||
            isUpdateMultipleStaffForSingleOffice
          ? locationState?.userList?.map((res) => res.officeId)
          : locationState.staffDetail.selectedOfficeList;
      payload.userIds =
        isUpdateMultipleStaffForMultipleOffices ||
        isUpdateMultipleStaffForSingleOffice
          ? allUserList.map((res) => res.staffMemberId)
          : [locationState.staffDetail.staffMemberId];
      payload.OwnerId = locationState?.ownerId;
      setGlobalLoading(true);
      const response = await updateBulkStaff(payload);
      if (response?.message) {
        toast.success(response?.message);
      }
      history.goBack();
    } catch (error) {
      toast.error(error?.message);
    } finally {
      setGlobalLoading(false);
    }
  };

  const performAction = async (
    transferWorkItemsTo,
    removeAsAdminFromAllOffices,
  ) => {
    const payload = payloadGenerate({
      location,
      state,
      profile,
      removeAsAdminFromAllOffices,
      transferWorkItemsTo,
      globalStaffPage: globalStaffPage,
    });
    payload.OwnerId = ownerId;
    if (globalStaffPage) {
      setGlobalLoading(true);
      try {
        const response = await addGlobalStaff(payload);
        if (response?.message) {
          toast.success(response?.message);
        }
        history.goBack();
      } catch (error) {
        toast.error(error?.message);
      } finally {
        setGlobalLoading(false);
      }
      return;
    }
    if (state.statusType === 3) {
      addEditStaffInvite(payload);
      return;
    }

    if (location?.state?.staffDetail && !state?.sikkaProviderId) {
      editStaff(payload);
    } else {
      payload.IsAutoAcceptStaff = state.IsAutoAcceptStaff;
      addEditStaff(payload);
    }
  };

  const toastHide = () => {
    setState((prev) => ({ ...prev, isToastView: false }));
  };

  const startSubstituteSelectionJourney = () => {
    updateState({
      substituteSelectorEvent: constants.staffActionEvents.removalAsAdmin,
    });
  };

  const exitSubstituteSelectionJourney = () => {
    updateState({ substituteSelectorEvent: null });
  };

  const substituteSelectorAction = (officeId, transferWorkItemsTo) => {
    exitSubstituteSelectionJourney();
    performAction(transferWorkItemsTo, officeId === null ? true : false);
  };

  const handlePickColor = (color) => {
    updateState({ profileColor: color });
  };

  // Determine email input conditions
  const shouldShowEmailForInvite = state.statusType && state.statusType === 3;
  const shouldShowEmailForEdit = state.statusType && state.statusType !== 3;
  const shouldShowEmailForSikka = !globalStaffDetail && state?.sikkaProviderId;
  const shouldShowEmailForNew = !globalStaffDetail && !state?.sikkaProviderId;
  const isSikkaDisabled = state?.sikkaProviderId;

  const getSelectedOption = useCallback(
    (matchedDesignationId) => {
      return (
        staff_designation?.designations_list?.find(
          (designation) => designation.id === +matchedDesignationId,
        ) || {}
      );
    },
    [staff_designation],
  );

  const isEditMode =
    !!(state.inviteId || state.staffId || locationState?.staffMemberId) &&
    !state?.sikkaProviderId;

  const allOfficeSelected = useMemo(
    () =>
      office_list?.data?.length > 0 &&
      office_list?.data?.length ===
        state.fields.reduce((prev, curr) => {
          prev += curr.officeIds.length;
          return prev;
        }, 0),
    [state.fields, office_list],
  );
  const selectedoffices = useMemo(
    () =>
      state.fields.reduce((prev, curr) => {
        prev = [...prev, ...curr.officeIds.map((res) => res.id)];
        return prev;
      }, []),
    [state.fields],
  );
  const handleTogglePopup = () => {
    setShowPopup((prev) => !prev);
  };

  useEffect(() => {
    const updatePosition = () => {
      if (showPopup && containerRef.current && popupRef.current) {
        const containerRect = containerRef.current.getBoundingClientRect();
        const popupRect = popupRef.current.getBoundingClientRect();
        const screenWidth = window.innerWidth;
        const screenHeight = window.innerHeight;
        const margin = 8;

        let left = containerRect.left;
        let top = containerRect.bottom + 8;

        if (left + popupRect.width + margin > screenWidth) {
          left = screenWidth - popupRect.width - margin;
        }

        if (left < margin) {
          left = margin;
        }

        if (top + popupRect.height + margin > screenHeight) {
          top = containerRect.top - popupRect.height - margin;
        }

        setPosition({ left, top });
      }
    };

    if (showPopup) {
      updatePosition();

      window.addEventListener("scroll", updatePosition);
      window.addEventListener("resize", updatePosition);
    }

    return () => {
      window.removeEventListener("scroll", updatePosition);
      window.removeEventListener("resize", updatePosition);
    };
  }, [showPopup]);
  const { visibleUsers, hiddenUsers } = useMemo(
    () => ({
      visibleUsers: allUserList.slice(0, 2),
      hiddenUsers: allUserList.slice(2),
    }),
    [allUserList],
  );

  // Render substitute selector if needed
  if (state.substituteSelectorEvent !== null) {
    const { staffDetail } = location?.state || {};
    const staff = {
      id: staffDetail.staffId,
      userId: staffDetail.staffMemberId,
      profilePicURL: staffDetail.profilePic,
      firstName: staffDetail.firstName,
      lastName: staffDetail.lastName,
      officeId: officeId,
    };
    return (
      <SubstituteSelectorFactory
        staff={staff}
        event={state.substituteSelectorEvent}
        onAction={substituteSelectorAction}
        onCancel={exitSubstituteSelectionJourney}
      />
    );
  }
  return (
    <div className="add-staff-block">
      {state.isToastView && statusMessage && (
        <Toast
          message={statusMessage}
          handleClose={toastHide}
          errorToast={
            !!isAddedError ||
            statusMessage ===
              "User account already exists and cannot be added as a staff member" ||
            statusMessage ===
              "Account admin has already been assigned to the office"
          }
        />
      )}

      <div className="container container-smd">
        <button className="back-btn">
          <BackButton t={t} onBack={() => history.goBack()} />
        </button>
      </div>
      <div className="container container-smd">
        <div
          className={
            styles.flex_heading +
            " " +
            "row no-gutters align-items-center page_title_margin_top"
          }
        >
          <div className="col-md-7">
            <h2 className="page-title">
              {isUpdateMultipleStaffForSingleOffice ||
              isUpdateMultipleStaffForMultipleOffices
                ? "Bulk Update"
                : isUpdateStaffForMultipleOffices
                  ? "Update Across Offices"
                  : isEditMode
                    ? t("accountOwner.editStaffMember")
                    : t("accountOwner.addStaffMember")}
            </h2>
            {globalStaffPage ? null : (
              <p className="sub-title mb-0">{officeNameForView}</p>
            )}
          </div>
          {(isUpdateMultipleStaffForSingleOffice ||
            isUpdateStaffForMultipleOffices ||
            isUpdateMultipleStaffForMultipleOffices) && (
            <button
              type="button"
              className={styles.question_btn}
              onClick={() => setIsInfoModalOpen(true)}
            >
              <img src={QuestionIcon} alt="QuestimIcon" />
              <p className="m-0">{t("navbar.help")}</p>
            </button>
          )}
        </div>
        {globalLoading && <Loader />}
        <div className="form-wrapper">
          {(isUpdateStaffForMultipleOffices ||
            isUpdateMultipleStaffForSingleOffice ||
            isUpdateMultipleStaffForMultipleOffices) && (
            <div
              className={`cbg-warning d-flex align-items-start mb-5 ${styles["info-box-warning"]}`}
            >
              <img
                src={tooltipImg}
                id="pick-color"
                alt="tooltip"
                className="ml-2 mt-1"
              />
              <Text size="14px" weight="400" color="#000000">
                {isUpdateMultipleStaffForMultipleOffices
                  ? `Update only the fields that need changes. Leave other fields blank to keep them unchanged. The updates will be applied to all selected staff members across every office they work in.`
                  : isUpdateMultipleStaffForSingleOffice
                    ? `Update only the fields that need changes. Leave other fields blank to keep them unchanged. The updates you enter will be applied to all selected staff members in the office.`
                    : `This screen updates staff information across all offices. Only
                enter values for the fields you want to change. Any field left
                blank will remain unchanged.`}
              </Text>
            </div>
          )}
          {visibleUsers.length > 0 && (
            <div className={addStaffStyles.office_list_main_container}>
              {visibleUsers?.map((item) => (
                <div
                  key={item.id}
                  className={addStaffStyles.office_list_container}
                  style={{ backgroundColor: item.color }}
                >
                  <img
                    src={item.profilePic || defautUserImage}
                    alt={item.profilePic || "user_image"}
                    className={addStaffStyles.office_list_image}
                    onError={(e) => {
                      e.currentTarget.src = defautUserImage;
                    }}
                  />
                  <div className={addStaffStyles.office_name_container}>
                    {(item.firstName || "") + " " + (item.lastName || "")}
                  </div>
                </div>
              ))}
              {hiddenUsers.length > 0 && (
                <div className={addStaffStyles.more_btn_wrapper}>
                  <button
                    className={addStaffStyles.more_btn}
                    onClick={handleTogglePopup}
                    ref={containerRef}
                  >
                    + {hiddenUsers.length} more
                  </button>

                  {showPopup && (
                    <div
                      className={addStaffStyles.popupOverlay}
                      ref={popupRef}
                      style={{
                        left: position.left,
                        top: position.top,
                      }}
                      onClick={(e) => e.stopPropagation()}
                    >
                      <div className={addStaffStyles.popupContainer}>
                        <div className={addStaffStyles.popupHeader}>
                          <button
                            className={addStaffStyles.closeBtn}
                            onClick={() => setShowPopup(false)}
                          >
                            <img
                              src={CloseIcon}
                              alt="close"
                              className={addStaffStyles.closeIcon}
                            />
                          </button>
                        </div>

                        <div className={addStaffStyles.popupContent}>
                          {hiddenUsers.map((item) => (
                            <div
                              key={item.id}
                              className={addStaffStyles.popupStaffCard}
                            >
                              <img
                                src={item.profilePic || defautUserImage}
                                alt={item.name}
                                className={
                                  addStaffStyles.office_list_image_modal
                                }
                                onError={(e) => {
                                  e.currentTarget.src = defautUserImage;
                                }}
                              />
                              <div
                                className={addStaffStyles.office_name_container}
                              >
                                {(item.firstName || "") +
                                  " " +
                                  (item.lastName || "")}
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
          )}
          <div className={`add${globalStaffPage ? "-global" : ""}-staff-form`}>
            {/* Personal Details */}
            {(isUpdateStaffForMultipleOffices &&
              (!selectedFilteredOffices ||
                typeof selectedFilteredOffices === "object")) ||
            isUpdateMultipleStaffForSingleOffice ||
            isUpdateMultipleStaffForMultipleOffices ? null : (
              <AccordionWrapper
                heading="Personal Details"
                reOpen={state.reOpen}
                setReOpen={() =>
                  setState((prev) => ({ ...prev, reOpen: false }))
                }
              >
                <TitleInput
                  value={state.title}
                  onChange={(v) => updateState({ title: v })}
                  error={state.errors.title}
                />

                <Input
                  Title={
                    <>
                      {t("form.fields.firstName")} <RedDot />
                    </>
                  }
                  Type="text"
                  Placeholder={t("form.placeholder1", {
                    field: t("form.fields.firstName"),
                  })}
                  Name="firstName"
                  HandleChange={InputChange}
                  Error={state.errors.firstname}
                  Value={state.firstName}
                />

                <Input
                  Title={
                    <>
                      {t("form.fields.lastName")}
                      <RedDot />
                    </>
                  }
                  Type="text"
                  Placeholder={t("form.placeholder1", {
                    field: t("form.fields.lastName"),
                  })}
                  Name="lastName"
                  HandleChange={InputChange}
                  Error={state.errors.lastname}
                  Value={state.lastName}
                />

                {/* Email Inputs - Consolidated */}
                {shouldShowEmailForInvite && (
                  <EmailInput
                    t={t}
                    value={state.emailId}
                    error={state.errors.emailId}
                    onChange={InputChange}
                    readOnly={
                      (state.statusType && state.statusType !== 3) ||
                      state.IsAutoAcceptStaff
                    }
                    disabled={state.IsAutoAcceptStaff}
                    classes={state?.emailId ? "disable-btns" : ""}
                  />
                )}

                {shouldShowEmailForSikka && (
                  <EmailInput
                    t={t}
                    value={state.emailId}
                    error={state.errors.emailId}
                    onChange={InputChange}
                    readOnly={state.IsAutoAcceptStaff}
                    disabled={state.IsAutoAcceptStaff}
                    classes={state?.emailId ? "disable-btns" : ""}
                  />
                )}

                {shouldShowEmailForNew && (
                  <EmailInput
                    t={t}
                    value={state.emailId}
                    error={state.errors.emailId}
                    onChange={InputChange}
                    readOnly={
                      (state.statusType && state.statusType !== 3) ||
                      state.IsAutoAcceptStaff
                    }
                    disabled={state.IsAutoAcceptStaff}
                  />
                )}

                {shouldShowEmailForEdit && (
                  <EmailInput
                    t={t}
                    value={state.emailId}
                    error={state.errors.emailId}
                    onChange={InputChange}
                    readOnly={
                      (state.statusType && state.statusType !== 3) ||
                      state.IsAutoAcceptStaff
                    }
                    disabled={state.IsAutoAcceptStaff}
                  />
                )}

                <Input
                  Title={
                    <>
                      {t("form.fields.contactNumber")}
                      {/* <RedDot /> */}
                    </>
                  }
                  Type="email"
                  Name="contactNumber"
                  Placeholder={t("form.placeholder1", {
                    field: t("form.fields.contactNumber"),
                  })}
                  HandleChange={InputChange}
                  Error={state.errors.contactNumber}
                  Value={state.contactNumber || ""}
                />

                <PrivacyNotice
                  address={state.address}
                  socialSecurityNumber={state.socialSecurityNumber}
                />

                <ProfileColorPicker
                  t={t}
                  selectedColor={state.profileColor}
                  onColorSelect={handlePickColor}
                  error={state.errors.profileColor}
                />
              </AccordionWrapper>
            )}
            <AccordionWrapper
              heading="Office Assignments"
              reOpen={state.reOpen}
              setReOpen={() => setState((prev) => ({ ...prev, reOpen: false }))}
              renderChildOnly={!globalStaffPage}
            >
              {state.fields.map((fieldObject, fieldIndex) => {
                const fieldUpdateFunction = (name, value) => {
                  updateFieldState(
                    { ...fieldObject, [name]: value },
                    fieldIndex,
                  );
                };
                const inputeChangeUpdate = (event) => {
                  const { name, value } = event.target;
                  updateFieldState(
                    { ...fieldObject, [name]: value },
                    fieldIndex,
                  );
                };
                const isNumberChangeUpdate = (evt) => {
                  let RegExpVal = new RegExp(/^\d+\.?\d*$/);
                  const { name, value } = evt.target;
                  if (value && !RegExpVal.test(value)) {
                    return;
                  }
                  updateFieldState(
                    { ...fieldObject, [name]: value },
                    fieldIndex,
                  );
                };
                return (
                  <AccordionWrapper
                    heading={"Office(s)"}
                    reOpen={state.reOpen}
                    setReOpen={() =>
                      setState((prev) => ({ ...prev, reOpen: false }))
                    }
                    key={fieldObject.key}
                    renderChildOnly={!globalStaffPage}
                    parentClass={
                      globalStaffPage ? styles["grey-background"] : undefined
                    }
                  >
                    <AccordionWrapper
                      heading={"Employment Details"}
                      reOpen={state.reOpen}
                      setReOpen={() =>
                        setState((prev) => ({ ...prev, reOpen: false }))
                      }
                      key={fieldObject.key}
                      renderChildOnly={globalStaffPage}
                      parentClass={
                        globalStaffPage ? styles["grey-background"] : undefined
                      }
                    >
                      {/* Employment Details */}
                      {globalStaffPage && (
                        <OfficeSelectionAndModal
                          setState={(updates) =>
                            updateFieldState(
                              {
                                ...fieldObject,
                                ...updates,
                                ReportToId: null,
                              },
                              fieldIndex,
                            )
                          }
                          isOfficeLoading={isOfficeLoading}
                          selectedOffice={fieldObject.officeIds}
                          states={fieldObject}
                          t={t}
                          office_list={office_list}
                          selectedoffices={selectedoffices}
                        />
                      )}
                      <div className="staff_employement_date c-field">
                        <Text size="13px" weight="400" color="#79869A">
                          {t("superAdminVendorManagement.employmentDate")}
                        </Text>
                        <div className="inputdate d-flex">
                          <ReactDatePickerCommon
                            dateFormat="dd-MM-yyyy"
                            className="c-form-control bg-transparent"
                            selected={fieldObject.employmentDate}
                            onChange={(e) => {
                              fieldUpdateFunction("employmentDate", e);
                            }}
                          />
                          {fieldObject.errors.employmentDate && (
                            <span className="error-msg">
                              Plase enter start date
                            </span>
                          )}
                        </div>
                      </div>
                      <StaffTypeRadio
                        t={t}
                        value={fieldObject.staffType}
                        onChange={inputeChangeUpdate}
                        fieldIndex={fieldIndex}
                        error={fieldObject.errors.staffType}
                      />
                      {(isUpdateStaffForMultipleOffices ||
                        isUpdateMultipleStaffForSingleOffice ||
                        isUpdateMultipleStaffForMultipleOffices) &&
                        fieldObject.staffType && (
                          <div
                            className={`cbg-warning d-flex align-items-start mb-5 ${styles["info-box-warning"]}`}
                          >
                            <img
                              src={tooltipImg}
                              id="pick-color"
                              alt="tooltip"
                              className="ml-2"
                            />
                            <div className="d-flex gap-xxs align-items-start flex-column">
                              <Text size="10px" weight="500" color="#2D3245">
                                This will apply across all offices where staff
                                members are assigned.Want to leave it unchanged?
                              </Text>
                              <button
                                type="button"
                                className="border-0 bg-transparent text-decoration-underline cfs-xs10"
                                onClick={() => {
                                  updateFieldState(
                                    {
                                      ...fieldObject,
                                      staffType: null,
                                    },
                                    fieldIndex,
                                  );
                                }}
                              >
                                Reset Job Type
                              </button>
                            </div>
                          </div>
                        )}
                      <SelectionAndModal
                        resetValues={
                          isUpdateStaffForMultipleOffices ||
                          isUpdateMultipleStaffForMultipleOffices
                        }
                        designations={staff_designation?.designations_list}
                        selectedDesignationOption={getSelectedOption(
                          fieldObject.designationId,
                        )}
                        selectDesignationOption={(value) => {
                          fieldUpdateFunction(
                            "designationId",
                            value.id.toString(),
                          );
                        }}
                        updateState={updateState}
                        fieldValues={state.fields}
                        designationError={fieldObject.errors.designationId}
                        selectedOwnerId={ownerId}
                        officeId={
                          isUpdateMultipleStaffForSingleOffice
                            ? [locationState?.officeId]
                            : [officeId]
                        }
                        setState={(updates) => {
                          updateFieldState(
                            {
                              ...fieldObject,
                              ...updates,
                            },
                            fieldIndex,
                          );
                        }}
                        states={fieldObject}
                        globalStaffPage={globalStaffPage}
                      />

                      <ScheduleSelection
                        t={t}
                        scheduleWeek={fieldObject.scheduleWeek}
                        schedule={fieldObject.schedule}
                        onScheduleChange={(e) =>
                          handleWeekDays(e, fieldObject, fieldIndex)
                        }
                        onScheduleEdit={(e, i) =>
                          handleWeekDaysEdit(e, i, fieldObject, fieldIndex)
                        }
                        error={fieldObject.errors.schedule}
                      />
                    </AccordionWrapper>

                    <OtherCompensationInputs
                      setState={(leaves) => {
                        fieldUpdateFunction("leaves", leaves);
                      }}
                      resetValues={
                        isUpdateStaffForMultipleOffices ||
                        isUpdateMultipleStaffForSingleOffice ||
                        isUpdateMultipleStaffForMultipleOffices
                      }
                      isCanAdminSeeHourlyRate={true}
                      hourlyRate={fieldObject.hourlyRate}
                      inputChange={inputeChangeUpdate}
                      isNumberKey={isNumberChangeUpdate}
                      states={fieldObject}
                      performanceReviewId={fieldObject.performanceReviewId}
                      reviewFormList={state.reviewFormList}
                      reOpen={state.reOpen}
                      setReOpen={() =>
                        setState((prev) => ({ ...prev, reOpen: false }))
                      }
                      parentClass={
                        globalStaffPage ? styles["grey-background"] : undefined
                      }
                      fieldIndex={fieldIndex}
                      globalStaffPage={globalStaffPage}
                    />

                    {/* Access & Permissions */}
                    <AccordionWrapper
                      heading="Access & Permissions"
                      reOpen={state.reOpen}
                      setReOpen={() =>
                        setState((prev) => ({ ...prev, reOpen: false }))
                      }
                      parentClass={
                        globalStaffPage ? styles["grey-background"] : undefined
                      }
                      changeExpandedClass={
                        state.fields.length > 1 ? " pt-2" : undefined
                      }
                    >
                      {isAccountOwner && (
                        <>
                          <div className="account-checkbox d-flex align-items-start">
                            <div className="ch-checkbox">
                              <label>
                                <input
                                  type="checkbox"
                                  name="isAdmin"
                                  onChange={(event) => {
                                    fieldUpdateFunction(
                                      "isAdmin",
                                      event.target.checked,
                                    );
                                  }}
                                  checked={fieldObject.isAdmin}
                                />
                                <span>
                                  {t("accountOwner.assignAccountAdminRole")}{" "}
                                  <img
                                    className="ml-2 cursor-pointer"
                                    onClick={() =>
                                      fieldUpdateFunction("tooltipObj", {
                                        ...fieldObject.tooltipObj,
                                        tooltipAdmin: true,
                                      })
                                    }
                                    id="TooltipAdmin"
                                    src={
                                      require("assets/images/info_black-tooltip.svg")
                                        .default
                                    }
                                    alt="icon"
                                  />
                                </span>
                              </label>

                              {fieldObject.isAdmin && (
                                <div className="ch-checkbox mt-4">
                                  <label>
                                    <input
                                      type="checkbox"
                                      name="showHourlyRate"
                                      onChange={(event) => {
                                        fieldUpdateFunction(
                                          "showHourlyRate",
                                          event.target.checked,
                                        );
                                      }}
                                      checked={fieldObject.showHourlyRate}
                                    />
                                    <span>
                                      {t("accountOwner.showHourlyRate")}
                                    </span>
                                  </label>
                                </div>
                              )}
                            </div>

                            <Tooltip
                              className="new-item-card-catalogue-tooltip"
                              isOpen={fieldObject.tooltipObj.tooltipAdmin}
                              placement="top"
                              target="TooltipAdmin"
                              toggle={() => {
                                fieldUpdateFunction("tooltipObj", {
                                  ...fieldObject.tooltipObj,
                                  tooltipAdmin:
                                    !fieldObject.tooltipObj.tooltipAdmin,
                                });
                              }}
                            >
                              {t("accountOwner.adminTooltipText")}
                            </Tooltip>
                          </div>
                        </>
                      )}

                      <div>
                        <RoleCheckbox
                          t={t}
                          id="Doctor"
                          checked={fieldObject.isDoctor}
                          onChange={(e) => {
                            const v = e.target.checked;
                            updateFieldState(
                              {
                                ...fieldObject,
                                isDoctor: v,
                                isReceptionist: v
                                  ? false
                                  : fieldObject.isReceptionist,
                              },
                              fieldIndex,
                            );
                          }}
                          label={t("accountOwner.assignDoctorRole")}
                          tooltipText={t("accountOwner.doctorTooltipText")}
                          disabled={isSikkaDisabled}
                          className={isSikkaDisabled ? "disable-btns" : ""}
                        />

                        <RoleCheckbox
                          t={t}
                          id="Receptionist"
                          checked={fieldObject.isReceptionist}
                          onChange={(e) => {
                            const v = e.target.checked;
                            updateFieldState(
                              {
                                ...fieldObject,
                                isReceptionist: v,
                                isDoctor: v ? false : fieldObject.isDoctor,
                              },
                              fieldIndex,
                            );
                          }}
                          label={t("accountOwner.assignReceptionistRole")}
                          tooltipText={t(
                            "accountOwner.receptionistTooltipText",
                          )}
                          disabled={isSikkaDisabled}
                          className={isSikkaDisabled ? "disable-btns" : ""}
                        />

                        <RoleCheckbox
                          t={t}
                          id="OrderManager"
                          checked={fieldObject.isOrderManager}
                          onChange={(e) => {
                            fieldUpdateFunction(
                              "isOrderManager",
                              e.target.checked,
                            );
                          }}
                          label={t("Com")}
                          tooltipText={t(
                            "accountOwner.ordermanagerTooltipText",
                          )}
                        />

                        <RoleCheckbox
                          className="mb-0"
                          t={t}
                          id="Inventory"
                          checked={fieldObject.IsInventoryManager}
                          onChange={(e) => {
                            fieldUpdateFunction(
                              "IsInventoryManager",
                              e.target.checked,
                            );
                          }}
                          label={t("Assign Inventory Manager")}
                          tooltipText={t("accountOwner.inventoryTooltipText")}
                        />
                      </div>
                    </AccordionWrapper>

                    {/* Delete for Global Staff */}
                    {state.fields.length > 1 && (
                      <DeleteOfficeAssignmentModal
                        deleteAssignment={() => {
                          const field = state.fields;
                          field.splice(fieldIndex, 1);
                          updateState({
                            fields: [...field],
                          });
                          toast.success(
                            "Office assignment deleted successfully.",
                          );
                        }}
                      />
                    )}
                  </AccordionWrapper>
                );
              })}
              {globalStaffPage && (
                <button
                  className={`button button-round button-border button-dark w-100 ${styles["btn-add-office"]}`}
                  onClick={() => {
                    submittedRef.current = false;
                    const field = state.fields;
                    field.push({
                      key: uuidv4(),
                      ...cloneDeep(fieldDefaultState),
                      ...(defaultDesignationId?.id && {
                        designationId: defaultDesignationId?.id,
                      }),
                    });
                    updateState({
                      fields: [...field],
                    });
                  }}
                  disabled={allOfficeSelected || !office_list?.data?.length}
                >
                  + Add office(s)
                </button>
              )}
            </AccordionWrapper>
            {isInfoModalOpen && (
              <AddStaffHelpGuideModal
                isOpen={isInfoModalOpen}
                onClose={setIsInfoModalOpen}
                globalStaffPage={isUpdateMultipleStaffForMultipleOffices}
                isUpdateStaffForMultipleOffices={
                  isUpdateStaffForMultipleOffices
                }
              />
            )}
            <FormButtons
              t={t}
              isEditMode={isEditMode}
              isToastView={state.isToastView}
              onSave={handleAddstaff}
              onCancel={() => history.goBack()}
              isUpdateStaffForMultipleOffices={
                isUpdateStaffForMultipleOffices ||
                isUpdateMultipleStaffForSingleOffice ||
                isUpdateMultipleStaffForMultipleOffices
              }
            />
          </div>
        </div>
      </div>
    </div>
  );
};

function mapStateToProps(state) {
  const {
    userProfile: { profile },
    staff: {
      staffDesignation,
      isLoading,
      statusMessage,
      isStaffAdd,
      isAddedError,
    },
    offices: { officeDetail },
    errors: { isError },
  } = state;

  return {
    staffDesignation,
    isLoading,
    isError,
    profile,
    statusMessage,
    isStaffAdd,
    isAddedError,
    officeDetail,
  };
}

export default connect(mapStateToProps, {
  getstaffDesignation,
  addEditStaff,
  addEditStaffInvite,
  editStaff,
  getOfficesDetail,
})(_isLoading(withTranslation()(AddStaff)));
